import { Icon } from "components";
import type { IconAdapterProps } from "./Icon.d";

const IconAdapter = ({ blok: { name, color, size } }: IconAdapterProps) => (
  <Icon name={name} color={color} size={size} />
);

export default IconAdapter;
